module.exports = __webpack_public_path__ + "media/andenes/minidock_hidraulico-411af090.webp";